import { RcFile } from 'antd/lib/upload'
import Api from '@vacationtracker/shared/services/api'
import axios from 'axios'

export const uploadAvatar = async (file: RcFile): Promise<string> => {
  const response = await Api.get(`/core/upload-avatar?type=${file.type}`, {
    headers: {
      'Content-Type': file.type,
    },
  })
  const uploadUrl: string = response.uploadUrl
  const imageUrl: string = response.imageUrl

  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  })

  return imageUrl
}
